// A class to provide bespoke select box styling.
export class SelectStyling {
  constructor (elem) {
    this.elem = elem

    this.setupEvents()
  }

  setupEvents () {
    this.elem.addEventListener('change', () => {
      this.elem.classList.toggle('select--selected', this.elem.value !== '')
    })
  }
}

export const setupSelectStyling = function (parent) {
  const elems = parent.querySelectorAll('select')

  const selectors = []

  for (const elem of elems) {
    selectors.push(new SelectStyling(elem))
  }

  return selectors
}

window.setupSelects = function (parent) {
  const selectors = setupSelectStyling(parent)

  return selectors
}
